import { EntityGridList } from "@/modules/common/components";
import { Pagination } from "@/modules/common/types/Pagination";
import { AdminUserResponse } from "@/service/response/admin-users";
import UserListHeader from "./UserListHeader";
import UserListLine from "./UserListLine";
import UserListSkeleton from "./UserListSkeleton";

interface UsersListParams {
  data?: Pagination<AdminUserResponse>;
  isLoading?: boolean;
  isFetching?: boolean;
  limit?: number;
  onChangePage: (nextPage: number) => void;
  onChangePageSize: (nextSize: number) => void;
}

const UsersList = (props: UsersListParams) => (
  <EntityGridList
    {...props}
    minWidthClassName="md:min-w-[1400px]"
    renderHeader={() => <UserListHeader />}
    renderRow={(user) => <UserListLine user={user} />}
    renderSkeleton={(limit) => <UserListSkeleton limit={limit} />}
  />
);

export default UsersList;
